import { WidgetType } from "@codemirror/view";

export class DescriptionItemWidget extends WidgetType {
    constructor(listDepth) {
        super();
        this.listDepth = listDepth;
    }

    toDOM() {
        const element = document.createElement("span");
        element.classList.add("ol-cm-description-item");
        this.setProperties(element);
        return element;
    }

    eq(widget) {
        return widget.listDepth === this.listDepth;
    }

    updateDOM(element) {
        this.setProperties(element);
        return true;
    }

    ignoreEvent(event) {
        return event.type !== "mousedown" && event.type !== "mouseup";
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }

    setProperties(element) {
        element.style.setProperty("--list-depth", String(this.listDepth));
    }
}
